import React, { FC, useContext, useEffect, ComponentType, useState, Fragment, useRef } from 'react';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { useLayoutEffect } from 'react';
import { Page } from '../ts/interfaces/Generic';

import FlightResultPage from 'components/flight/Result/Main';
import FlightDetailsPage from 'components/flight/Details/Main';
import MultiFlightPage from 'components/flight/Details/MultiDetailsFlight';
import FlightBookPage from 'components/flight/Book/Main';
import MultiFlightBookPage from 'components/flight/Book/MultiFlightBook';
import FlightSuccessPage from 'components/flight/Book/SuccessFlightPage';
import FlightPaymentPage from 'components/flight/Book/FlightPaymentPage';
import BookHotelPage from 'components/hotel/Book/BookHotelPage';
import DetailsHotelPage from 'components/hotel/Details/DetailsHotelPage';
import SuccessHotelPage from 'components/hotel/Book/SuccessHotelPage';
import BookPayment from 'components/hotel/Book/BookPayment';
import ResultTransferPage from 'components/transfer/Result/ResultTransferPage';
import BookTransferPage from 'components/transfer/Book/BookTransferPage';
import SuccessTransferPage from 'components/transfer/Book/SuccessTransferPage';
import TransferPaymentPage from 'components/transfer/Book/TransferPaymentPage';
import ResultTourPage from 'components/package/Results/ResultTourPage';
import DetailsPackagePage from 'components/package/Details/DetailsPackagePage';
import DetailsTourPage from 'components/package/Details/DetailsTourPage';
import SuccessPackagePage from 'components/package/Book/SuccessPackagePage';
import BookPackagePage from 'components/package/Book/BookPackagePage';
import ResultPackagePage from 'components/package/Results/ResultPackagePage';
import PackageOfflineDetailsPage from 'components/package/Offline/PackageOfflineDetailsPage';
import PackageOfflineBookPage from 'components/package/Offline/PackageOfflineBookPage';
import PackageOfflineSuccessPage from 'components/package/Offline/PackageOfflineSuccessPage';
import PaymentPackagePage from 'components/package/Book/PaymentPackagePage';
import PackageOfflinePaymentPage from 'components/package/Offline/PackageOfflinePaymentPage';
import { MainContext } from '../contexts/MainContext';
import { HotelConfigContext } from '../contexts/HotelConfigContext';
import DetailsDynamicPage from 'components/dynamic/Details/DetailsDynamicPage';
import BookDynamicPage from 'components/dynamic/Book/BookDynamicPage';
import DetailsPredefinedPage from 'components/dynamic/Details/DetailsPredefinedPage';
import DetailsDynamicFHPage from 'components/dynamic/Details/DetailsDynamicFHPage';
import DynamicPaymentPage from 'components/dynamic/Book/DynamicPaymentPage';
import DynamicSuccessPage from 'components/dynamic/Book/DynamicSuccessPage';
import Login from 'components/shared/Login';
import FailPage from 'components/shared/FailPage';
import StatusXXPage from 'components/shared/StatusXXPage';
import NotFoundPage from 'components/shared/NotFoundPage';
import PreviewPage from 'components/shared/MyOrders/PreviewPage';
import MainMOPage2 from 'components/shared/MyOrders/MainMOPage2';
import ProposalPage from 'components/shared/Proposal/Single/ProposalPage';
import ProposalHtml from 'components/shared/Proposal/ProposalHtml';
import ProfilePage from 'components/shared/ProfilePage';
import MultiPaymentPage from 'components/shared/MultiPaymentPage';
import GroupRequestPage from 'components/shared/GroupRequestPage';
import BookRevolutPage from 'components/shared/BookRevolutPage';
import MyOrderPaymentPage from 'components/shared/MyOrders/MyOrderPaymentPage';
import TripBuilderPage from 'components/shared/Proposal/TB/TripBuilderPage';
import { cdnUrl } from '../constants/generic';
import { getRandomImage } from '../services/config';
import MainFlightsPage from './MainFlightsPage';
import MainPackagePage from './MainPackagePage';
import MainTransferPage from './MainTransferPage';
import MainDynamicPage from './MainDynamicPage';
import MainPage from './MainPage';
import MainHPage from './MainHPage';
import CResultHotelPage from './ResultHotelPage';

export const ProposalPageWr: FC = () => {
  return <ProposalHtml />;
};

const LoginPage: FC = () => {
  const { isEnigma } = useContext(MainContext);
  useEffect(() => {
    if (isEnigma) return;
    (async () => {
      const response = await getRandomImage();

      const elemLogin = document.querySelector('.login-top') as HTMLElement;
      elemLogin.style.backgroundImage = `url(${cdnUrl + response?.imageUrl})`;
    })();
  }, [isEnigma]);

  return (
    <div className="login-top">
      <Login />
    </div>
  );
};

const MainWrPage: FC = () => {
  const isEnigma = useContext(MainContext).isEnigma;
  return <MainPage isEnigma={isEnigma || false} />;
};

const HotelRouteWrapper: FC<{ Component: ComponentType<Object>; hotelIndex?: number }> = ({
  Component,
  hotelIndex,
}) => (
  <HotelConfigContext.Provider value={{ hotelIndex }}>
    <Component />
  </HotelConfigContext.Provider>
);

const Router = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, setUser, setLoginAsUser, globals, initSiteData } = useContext(MainContext);
  const [packagesAvailable, setPackagesAvailable] = useState(false);
  const [flightsAvailable, setFlightsAvailable] = useState(false);
  const isFirstUserRef = useRef(true);
  const [moPageKey, setMoPageKey] = useState(0);

  useEffect(() => {
    if (isFirstUserRef.current) {
      isFirstUserRef.current = false;
      return;
    }
    const timer = setTimeout(() => {
      setMoPageKey((k) => k + 1);
    }, 100);
    return () => clearTimeout(timer);
  }, [user?.userCode]);
  useEffect(() => {
    if (initSiteData?.other?.packagesAvailable) {
      setPackagesAvailable(true);
    }
    if (initSiteData?.other?.flightsAvailbale) {
      setFlightsAvailable(true);
    }
  }, [initSiteData]);

  useEffect(() => {
    if (globals?.useCognito) {
      if (location.pathname === '/login') {
        navigate('');
      }
      return;
    };
    if (
      (!user || !user.isAuth) &&
      location.pathname !== '/login' &&
      location.pathname !== '/manager-login' &&
      location.pathname !== '/cognito-login' &&
      location.pathname !== '/my-orders/payment' &&
      location.pathname !== '/fail' &&
      location.pathname !== '/status-xx' &&
      !location.pathname.includes('/proposal/preview') &&
      !location.pathname.includes('/proposal/trip-builder')
    ) {
      navigate('/login');
    }
  }, [location]); // eslint-disable-line

  useEffect(() => {
    const loginAsUser = localStorage.getItem('loginAsUser');
    if (loginAsUser) {
      const user = localStorage.getItem('user');
      const loginAsUserObj = JSON.parse(loginAsUser);
      const userObj = JSON.parse(user || '{}');
      const loginAsTime = new Date(userObj.loginAsTime);
      const loginAsDuration = userObj.loginAsDuration;

      const now = new Date();

      const diffMinutes = Math.floor((now.getTime() - loginAsTime.getTime()) / (1000 * 60));

      if (diffMinutes > loginAsDuration) {
        localStorage.removeItem('loginAsUser');
        localStorage.setItem('user', loginAsUser);
        setLoginAsUser(undefined);
        setUser(loginAsUserObj);
      }
    }
  }, [location.pathname, setLoginAsUser, setUser]);

  useEffect(() => {
    if (user && user.isAuthExpired) {
      navigate('/login');
      const newUser = { ...user, isAuthExpired: false };
      setUser(newUser);
      localStorage.setItem('user', JSON.stringify(newUser));
    }
  }, [user]); // eslint-disable-line

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  const pages: Page[] = [
    { path: '/', component: MainWrPage },
    ...(flightsAvailable
      ? [
        { path: '/flights', component: MainFlightsPage },
        { path: '/flights/results', component: FlightResultPage },
        { path: '/flight/details', component: FlightDetailsPage },
        { path: '/multiflight/details', component: MultiFlightPage },
        { path: '/multiflight/book', component: MultiFlightBookPage },
        { path: '/flight/book', component: FlightBookPage },
        { path: '/flight/payment', component: FlightPaymentPage },
        { path: '/flight/success', component: FlightSuccessPage },
      ]
      : []),
    { path: '/tours', component: MainPackagePage },
    { path: '/tours/results', component: ResultTourPage },
    { path: '/tour/details', component: DetailsTourPage },
    { path: '/tour/book', component: BookPackagePage },
    { path: '/tour/payment', component: PaymentPackagePage },
    { path: '/tour/success', component: SuccessPackagePage },
    ...(packagesAvailable
      ? [
        { path: '/ilpackages', component: MainPackagePage },
        { path: '/ilpackages/results', component: ResultPackagePage },
        { path: '/ilpackage/details', component: DetailsPackagePage },
        { path: '/ilpackage/book', component: BookPackagePage },
        { path: '/ilpackage/payment', component: PaymentPackagePage },
        { path: '/ilpackage/success', component: SuccessPackagePage },
      ]
      : []),
    { path: '/offline-package/details', component: PackageOfflineDetailsPage },
    { path: '/offline-package/payment', component: PackageOfflinePaymentPage },
    { path: '/offline-package/book', component: PackageOfflineBookPage },
    { path: '/offline-package/success', component: PackageOfflineSuccessPage },
    { path: '/transfers', component: MainTransferPage },
    { path: '/transfers/results', component: ResultTransferPage },
    { path: '/transfer/book', component: BookTransferPage },
    { path: '/transfer/payment', component: TransferPaymentPage },
    { path: '/transfer/success', component: SuccessTransferPage },
    { path: '/dynamic', component: MainDynamicPage },
    { path: '/dynamic/details', component: DetailsDynamicPage },
    { path: '/dynamic/predefined', component: DetailsPredefinedPage },
    { path: '/dynamic/payment', component: DynamicPaymentPage },
    { path: '/dynamic/success', component: DynamicSuccessPage },
    { path: '/dynamic-fh', component: MainDynamicPage },
    { path: '/dynamic-fh/details', component: DetailsDynamicFHPage },
    { path: '/dynamic/book', component: BookDynamicPage },
    { path: '/fail', component: FailPage },
    { path: '/status-xx', component: StatusXXPage },
    { path: '/preview', component: PreviewPage },
    { path: '/proposal', component: ProposalPage },
    { path: '/proposal/preview', component: ProposalPageWr },
    { path: '/profile', component: ProfilePage },
    { path: '/hotel/multi-payment', component: MultiPaymentPage },
    { path: '/group', component: GroupRequestPage },
    { path: '/backend/Payments/Revolut', component: BookRevolutPage },
    { path: '/my-orders/payment', component: MyOrderPaymentPage },
    { path: '/hotels2/results', component: () => <></> },
    { path: '/hotels/results', component: () => <></> },
    { path: '/my-orders', component: () => <></> },
    { path: '/proposal/trip-builder', component: TripBuilderPage },
  ];

  if (!globals?.useCognito) {
    pages.push({ path: '/login', component: LoginPage });
  }

  const hotelPages: Page[] = [
    { path: '/hotels', component: MainHPage },
    { path: '/hotel/details', component: DetailsHotelPage },
    { path: '/hotel/book', component: BookHotelPage },
    { path: '/hotel/payment', component: BookPayment },
    { path: '/hotel/success', component: SuccessHotelPage },
  ];

  const hotel2Pages: Page[] = [
    { path: '/hotels2', component: MainHPage },
    { path: '/hotel2/details', component: DetailsHotelPage },
    { path: '/hotel2/book', component: BookHotelPage },
    { path: '/hotel2/payment', component: BookPayment },
    { path: '/hotel2/success', component: SuccessHotelPage },
  ];

  const dynamicPages: Page[] = [
    { path: '/dynamic/payment', component: DynamicPaymentPage },
    { path: '/dynamic/success', component: DynamicSuccessPage },
    { path: '/dynamic-fh', component: MainDynamicPage },
    { path: '/dynamic-fh/details', component: DetailsDynamicFHPage },
    { path: '/dynamic/book', component: BookDynamicPage },
  ];

  return (
    <Fragment>
      <div style={{ display: location.pathname === '/hotels/results' ? 'block' : 'none' }}>
        <HotelRouteWrapper Component={CResultHotelPage} />
      </div>
      <div style={{ display: location.pathname === '/hotels2/results' ? 'block' : 'none' }}>
        <HotelRouteWrapper Component={CResultHotelPage} hotelIndex={2} />
      </div>
      <div style={{ display: location.pathname === '/my-orders' ? 'block' : 'none' }}>
        <MainMOPage2 key={moPageKey} />
      </div>

      <Routes>
        {pages.map(({ component: Component, path }) => {
          return <Route key={path} element={<Component />} path={path} />;
        })}

        {hotelPages.map(({ component: Component, path }) => {
          return (
            <Route
              key={path}
              element={<HotelRouteWrapper Component={Component} />}
              path={path}
            />
          );
        })}

        {hotel2Pages.map(({ component: Component, path }) => {
          return (
            <Route
              key={path}
              element={<HotelRouteWrapper Component={Component} hotelIndex={2} />}
              path={path}
            />
          );
        })}

        {flightsAvailable &&
          dynamicPages.map(({ component: Component, path }) => {
            return <Route key={path} element={<Component />} path={path} />;
          })}

        <Route path="*" element={<NotFoundPage />} />
      </Routes>

    </Fragment>
  );
};

export default Router;
